import { render, staticRenderFns } from "./openPay.vue?vue&type=template&id=22f44528&scoped=true"
import script from "./openPay.vue?vue&type=script&lang=js"
export * from "./openPay.vue?vue&type=script&lang=js"
import style0 from "./openPay.vue?vue&type=style&index=0&id=22f44528&prod&lang=stylus&scoped=true"
import style1 from "./openPay.vue?vue&type=style&index=1&id=22f44528&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f44528",
  null
  
)

export default component.exports